import { coordToArr } from "@nova/calculate-geospatial"
import { SatelliteFlight } from "@nova/protobuf"
import { zoomToShowPoints } from "features/map/zoom/thunks"
import store from "integrations/redux/store"
import { decideTakeSnapshotOfSecondaryLayer } from "features/map/control/module"

export const zoomToSatellite = (entity: SatelliteFlight) => {
    decideTakeSnapshotOfSecondaryLayer()
    store.dispatch(
        zoomToShowPoints({
            points: entity.region.map((e) => coordToArr(e) as [number, number]),
        })
    )
}
